import React from 'react'
import { OrderListWrap } from './styles'
import { OrderListProps } from './types'
import { useLocation } from 'react-router'

const OrderList = () => {

  const location = useLocation()

  const options = location?.state?.shopOptions

  const shopDetail = location?.state?.shopDetail

  const count = location?.state?.count

  const thumbnail = shopDetail?.thumbnail && JSON.parse(shopDetail?.thumbnail)[0].path
  const shopImage = shopDetail?.images && JSON.parse(shopDetail.images)[0].path

  return (
    <OrderListWrap>
      {
        shopDetail.type === 1 && <div>
          <div className="figure">
            <span style={{background: `url('${process.env.REACT_APP_BASE_URL}${shopImage}') no-repeat center / cover`}}></span>
          </div>
          <p>상품 : {shopDetail.name}</p>
          <p>판매가 : {shopDetail.price.toLocaleString()}원</p>
        </div>
      }
      <ul>
        {
          options && options.filter((item: any) => item.cnt > 0).map((item: any, index: number) => {
            return (
              <li key={index}>
                <div
                  className="figure"
                  style={{background: `url(${process.env.REACT_APP_BASE_URL}${thumbnail}) no-repeat center / cover`}}
                ></div>
                <div className="info-wrap">
                  <div className="info">
                    <div className="name">{item.name}</div>
                    {
                      shopDetail?.type === 1 ?
                        <div className="price">
                          <strong>{(Number(item.original_price || shopDetail?.price || 0) * item.cnt).toLocaleString('ko-KR')}</strong> 원
                        </div>
                      : <div className="price">
                          <strong>{((item.original_price + item.tax) * item.cnt).toLocaleString('ko-KR')}</strong> 원
                        </div>
                    }
                    {
                      shopDetail?.type === 1 && (item.option_group || item.option_value) && (
                        <div className="price">
                          {`${item.option_group || '옵션'} : ${item.option_value || item.name}`}
                        </div>
                      )
                    }
                  </div>
                  <div className="count">
                    구매수량 : {item.cnt}
                  </div>
                </div>
              </li>
            )
          })
        }
      </ul>
    </OrderListWrap>
  )
}

export default OrderList
